import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-of-service", label: "Terms" },
  { to: "/privacy-choices", label: "Privacy Choices" },
  { to: "/delete-account", label: "Delete Account" },
  { to: "/support", label: "Support" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 border-b ${
        scrolled ? "bg-[#F9F9F6]/95 backdrop-blur-md border-[#E0E0D9]" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand" className="group flex items-center gap-3">
          <span className="w-2.5 h-2.5 bg-[#C6826D] rotate-45 transition-transform duration-500 group-hover:rotate-[225deg]" />
          <span className="font-mono-meta text-[11px] uppercase tracking-[0.28em] text-[#0A0A0A]">
            ProBeauty&nbsp;Connect
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "")}`}
              className={`text-sm tracking-tight transition-colors duration-200 hover:text-[#C6826D] ${
                pathname === l.to ? "text-[#0A0A0A]" : "text-[#525252]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <button
          data-testid="nav-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#0A0A0A]"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#F9F9F6] border-t border-[#E0E0D9]">
          <div className="px-6 py-4 flex flex-col">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-mobile-link-${l.to.replace("/", "")}`}
                className="py-3 text-[#0A0A0A] border-b border-[#E0E0D9] last:border-0"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
